// extracted by mini-css-extract-plugin
export default {"wrapper":"AddPortmoneServiceModal_wrapper__UZzzO","service":"AddPortmoneServiceModal_service__pU8Cg"};